module.exports = __webpack_public_path__ + "vi.svg?8a178e2ccba3c073eff08cb67977c858";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/vi.svg
// module id = 1434
// module chunks = 0